(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5288],{

/***/ 54039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6089);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(93717);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71293);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65028);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(57747);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(24880);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(22757);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(93108);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(81136);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(47710);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73064);
/* harmony import */ var _fusion_icons_react_interface__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52597);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(86893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19559);
/* harmony import */ var src_pages_learn_about_calc_LearningHubLinks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6935);
/* harmony import */ var _components_LinkWithQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69091);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67848);
/* harmony import */ var _models_StrategyUrls__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82649);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94301);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(isomorphic_fetch__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















function InfoPanel() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Stack */ .K, {
    direction: "row",
    layerStyle: "panel",
    p: 4,
    spacing: 4,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Image */ .E, {
      src: "/images/iceblock.svg"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Flex */ .k, {
      alignItems: "center",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
        textStyle: "body",
        children: "Remember, marketing material is typically designed to make you feel emotional and impulsive. Don't let fear and hype make your decisions for you."
      })
    })]
  });
}

function StrategyCard(_ref) {
  var name = _ref.name,
      description = _ref.description,
      advanced = _ref.advanced,
      icon = _ref.icon,
      href = _ref.href,
      learnMoreHref = _ref.learnMoreHref,
      enabled = _ref.enabled;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(),
      query = _useRouter.query;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Stack */ .K, {
    direction: ['row', null, null, 'column'],
    p: 4,
    layerStyle: "panel",
    width: ['full', null, null, 56],
    gap: 4,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Flex */ .k, {
      direction: "column",
      flexGrow: 1,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Flex */ .k, {
        mb: 4,
        children: [icon, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Spacer */ .L, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .xu, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Badge */ .C, {
            size: "xs",
            colorScheme: advanced ? 'blue' : undefined,
            children: advanced ? 'Advanced Strategy' : 'Basic Strategy'
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .Heading */ .X, {
        size: "md",
        mb: 2,
        children: name
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
        textStyle: "body-xs",
        children: description
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Flex */ .k, {
      justifyContent: "center",
      direction: "column",
      alignContent: "center",
      children: [enabled ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_LinkWithQuery__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        href: {
          pathname: href !== null && href !== void 0 ? href : '',
          query: query
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Button */ .z, {
          mb: 2,
          children: "Get started"
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Button */ .z, {
        mb: 2,
        cursor: "unset",
        color: "navy",
        colorScheme: "grey",
        children: "Coming soon"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_LinkWithQuery__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        href: learnMoreHref,
        passHref: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Button */ .z, {
          as: "a",
          target: "_blank",
          colorScheme: "blue",
          variant: "ghost",
          children: "Learn more"
        })
      })]
    })]
  });
}

StrategyCard.defaultProps = {
  enabled: false,
  href: undefined,
  advanced: false
};

function useFearAndGreed() {
  var _useQuery = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_20__/* .useQuery */ .a)(['fear-and-greed-index'], /*#__PURE__*/(0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
    var response;
    return _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("https://api.alternative.me/fng/");

          case 2:
            response = _context.sent;

            if (response.ok) {
              _context.next = 5;
              break;
            }

            throw new Error('Failed to fetch fear and greed index.');

          case 5:
            return _context.abrupt("return", response.json());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading;

  return {
    index: data === null || data === void 0 ? void 0 : data.data[0].value,
    classification: data === null || data === void 0 ? void 0 : data.data[0].value_classification,
    isLoading: isLoading
  };
}

function FearGreedStrategyRecommendation(_ref3) {
  var isAccumulation = _ref3.isAccumulation;

  var _useFearAndGreed = useFearAndGreed(),
      index = _useFearAndGreed.index,
      classification = _useFearAndGreed.classification,
      isLoading = _useFearAndGreed.isLoading;

  var setStrategyRecommendation = isAccumulation ? 'accumulation' : 'take profit';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Badge */ .C, {
    colorScheme: "green",
    px: 4,
    py: 1,
    layerStyle: "panel",
    whiteSpace: "normal",
    bg: "deepHorizon",
    textAlign: "center",
    children: isLoading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .Spinner */ .$, {
      w: 3,
      h: 3
    }) : index ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
      children: ["According to the", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_LinkWithQuery__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        passHref: true,
        href: "https://alternative.me/crypto/fear-and-greed-index/",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
          as: "a",
          textDecoration: "underline",
          target: "_blank",
          children: "Fear & Greed index score"
        })
      }), ": ", index, " (", classification, "), it may be a good time to use ", setStrategyRecommendation, " strategies"]
    }) : null
  });
}

function Strategies() {
  var _useFearAndGreed2 = useFearAndGreed(),
      index = _useFearAndGreed2.index;

  var showFearAndGreedAccumulate = index < 41;
  var showFearAndGreedProfit = index > 59;

  function accumulationStrategies() {
    return [{
      name: 'Standard DCA In',
      description: 'Customise your own dollar-cost average buying strategy.',
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        stroke: "white",
        strokeWidth: 2,
        as: _fusion_icons_react_interface__WEBPACK_IMPORTED_MODULE_3__/* .Fullscreen2Icon */ .ym1,
        width: 8,
        height: 8
      }),
      enabled: true,
      href: _models_StrategyUrls__WEBPACK_IMPORTED_MODULE_8__/* ["default"].DCAIn */ .Z.DCAIn,
      learnMoreHref: src_pages_learn_about_calc_LearningHubLinks__WEBPACK_IMPORTED_MODULE_6__/* .LearningHubLinks.Dca */ .B.Dca
    }, {
      name: 'Algorithm DCA+ In',
      description: 'DCA into large cap assets based on market risk.',
      advanced: true,
      href: _models_StrategyUrls__WEBPACK_IMPORTED_MODULE_8__/* ["default"].DCAPlusIn */ .Z.DCAPlusIn,
      enabled: true,
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        stroke: "white",
        strokeWidth: 2,
        as: _fusion_icons_react_interface__WEBPACK_IMPORTED_MODULE_3__/* .Code3Icon */ .PtX,
        width: 8,
        height: 8
      }),
      learnMoreHref: src_pages_learn_about_calc_LearningHubLinks__WEBPACK_IMPORTED_MODULE_6__/* .LearningHubLinks.DcaPlus */ .B.DcaPlus
    }, {
      name: 'Weighted Scale In',
      description: 'Buy more when the price is low, and less when the price is high.',
      advanced: true,
      enabled: true,
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        stroke: "white",
        strokeWidth: "px",
        as: react_icons_fi__WEBPACK_IMPORTED_MODULE_23__/* .FiDivide */ .JnT,
        width: 8,
        height: 8
      }),
      href: _models_StrategyUrls__WEBPACK_IMPORTED_MODULE_8__/* ["default"].WeightedScaleIn */ .Z.WeightedScaleIn,
      learnMoreHref: src_pages_learn_about_calc_LearningHubLinks__WEBPACK_IMPORTED_MODULE_6__/* .LearningHubLinks.WeightedScale */ .B.WeightedScale
    }, {
      name: 'Streaming Swap',
      description: 'Reduce slippage by swapping smaller amounts over time.',
      advanced: false,
      enabled: true,
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        stroke: "white",
        strokeWidth: "px",
        as: react_icons_fi__WEBPACK_IMPORTED_MODULE_23__/* .FiAperture */ .Ry6,
        width: 8,
        height: 8
      }),
      href: _models_StrategyUrls__WEBPACK_IMPORTED_MODULE_8__/* ["default"].StreamingSwap */ .Z.StreamingSwap,
      learnMoreHref: src_pages_learn_about_calc_LearningHubLinks__WEBPACK_IMPORTED_MODULE_6__/* .LearningHubLinks.MoreAboutCalc */ .B.MoreAboutCalc
    }];
  }

  function takeProfitStrategies() {
    return [{
      name: 'Standard DCA Out',
      description: 'Dollar-cost average out of an asset with ease.',
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        stroke: "white",
        strokeWidth: 2,
        as: _fusion_icons_react_interface__WEBPACK_IMPORTED_MODULE_3__/* .Fullscreen1Icon */ .KZX,
        width: 8,
        height: 8
      }),
      enabled: true,
      href: _models_StrategyUrls__WEBPACK_IMPORTED_MODULE_8__/* ["default"].DCAOut */ .Z.DCAOut,
      learnMoreHref: src_pages_learn_about_calc_LearningHubLinks__WEBPACK_IMPORTED_MODULE_6__/* .LearningHubLinks.Dca */ .B.Dca
    }, {
      name: 'Algorithm DCA+ Out',
      description: 'DCA out of large cap assets based on market risk.',
      advanced: true,
      href: _models_StrategyUrls__WEBPACK_IMPORTED_MODULE_8__/* ["default"].DCAPlusOut */ .Z.DCAPlusOut,
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        stroke: "white",
        strokeWidth: 2,
        as: _fusion_icons_react_interface__WEBPACK_IMPORTED_MODULE_3__/* .Code3Icon */ .PtX,
        width: 8,
        height: 8
      }),
      enabled: true,
      learnMoreHref: src_pages_learn_about_calc_LearningHubLinks__WEBPACK_IMPORTED_MODULE_6__/* .LearningHubLinks.DcaPlus */ .B.DcaPlus
    }, {
      name: 'Weighted Scale Out',
      description: 'Sell more when the price is high, and less when the price is low.',
      advanced: true,
      enabled: true,
      href: _models_StrategyUrls__WEBPACK_IMPORTED_MODULE_8__/* ["default"].WeightedScaleOut */ .Z.WeightedScaleOut,
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        stroke: "white",
        strokeWidth: "px",
        as: react_icons_fi__WEBPACK_IMPORTED_MODULE_23__/* .FiDivide */ .JnT,
        width: 8,
        height: 8
      }),
      learnMoreHref: src_pages_learn_about_calc_LearningHubLinks__WEBPACK_IMPORTED_MODULE_6__/* .LearningHubLinks.WeightedScale */ .B.WeightedScale
    }, {
      name: 'Streaming Swap',
      description: 'Reduce slippage by swapping smaller amounts over time.',
      advanced: false,
      enabled: true,
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        stroke: "white",
        strokeWidth: "px",
        as: react_icons_fi__WEBPACK_IMPORTED_MODULE_23__/* .FiAperture */ .Ry6,
        width: 8,
        height: 8
      }),
      href: _models_StrategyUrls__WEBPACK_IMPORTED_MODULE_8__/* ["default"].StreamingSwap */ .Z.StreamingSwap,
      learnMoreHref: src_pages_learn_about_calc_LearningHubLinks__WEBPACK_IMPORTED_MODULE_6__/* .LearningHubLinks.MoreAboutCalc */ .B.MoreAboutCalc
    }];
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Stack */ .K, {
    direction: "column",
    spacing: 8,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Stack */ .K, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Wrap */ .E, {
        spacing: 2,
        pb: 1,
        shouldWrapChildren: true,
        align: "center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .Heading */ .X, {
          size: "md",
          children: "Accumulation strategies"
        }), showFearAndGreedAccumulate && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(FearGreedStrategyRecommendation, {
          isAccumulation: true
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Flex */ .k, {
        gap: 8,
        flexDirection: "row",
        wrap: "wrap",
        children: accumulationStrategies().map(function (strategy) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(StrategyCard, _objectSpread({}, strategy), strategy.name);
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(InfoPanel, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Stack */ .K, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Wrap */ .E, {
        spacing: 2,
        pb: 1,
        shouldWrapChildren: true,
        align: "center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .Heading */ .X, {
          mb: 1,
          size: "md",
          children: "Take Profit strategies"
        }), showFearAndGreedProfit && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(FearGreedStrategyRecommendation, {})]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Flex */ .k, {
        gap: 8,
        flexDirection: "row",
        wrap: "wrap",
        children: takeProfitStrategies().map(function (strategy) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(StrategyCard, _objectSpread({}, strategy), strategy.name);
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Stack */ .K, {
      direction: "row",
      layerStyle: "panel",
      p: 4,
      spacing: 4,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Image */ .E, {
        src: "/images/moneyBag.svg"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Flex */ .k, {
        alignItems: "center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
          textStyle: "body",
          children: "Set your profit taking goals when accumulating an asset, because when assets start pumping, euphoria kicks in."
        })
      })]
    })]
  });
}

function CreateStrategy() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Stack */ .K, {
    direction: "column",
    spacing: 8,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Stack */ .K, {
      spacing: 2,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .Heading */ .X, {
        size: "lg",
        children: "Set up a smart swap strategy"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
        textStyle: "body",
        children: "The smartest way to enter and exit positions, complimented with pre- and post-swap automation to save time and counter emotional decision making."
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(Strategies, {})]
  });
}

CreateStrategy.getLayout = _components_Layout__WEBPACK_IMPORTED_MODULE_5__/* .getSidebarLayout */ .M;
/* harmony default export */ __webpack_exports__["default"] = (CreateStrategy);

/***/ }),

/***/ 84206:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-strategy",
      function () {
        return __webpack_require__(54039);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47710:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Wrap; }
/* harmony export */ });
/* unused harmony export WrapItem */
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25432);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22548);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client'

// src/wrap.tsx
;



var Wrap = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function Wrap2(props, ref) {
  const {
    spacing = "0.5rem",
    spacingX,
    spacingY,
    children,
    justify,
    direction,
    align,
    className,
    shouldWrapChildren,
    ...rest
  } = props;
  const _children = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => shouldWrapChildren ? react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (child, index) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapItem, { children: child }, index)) : children,
    [children, shouldWrapChildren]
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.div */ .m.div, { ref, className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-wrap", className), ...rest, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.ul */ .m.ul,
    {
      className: "chakra-wrap__list",
      __css: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: justify,
        alignItems: align,
        flexDirection: direction,
        listStyleType: "none",
        gap: spacing,
        columnGap: spacingX,
        rowGap: spacingY,
        padding: "0"
      },
      children: _children
    }
  ) });
});
Wrap.displayName = "Wrap";
var WrapItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function WrapItem2(props, ref) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.li */ .m.li,
    {
      ref,
      __css: { display: "flex", alignItems: "flex-start" },
      className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-wrap__listitem", className),
      ...rest
    }
  );
});
WrapItem.displayName = "WrapItem";


//# sourceMappingURL=chunk-7ELO524Q.mjs.map

/***/ }),

/***/ 24880:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77030);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33179);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25432);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'

// src/badge.tsx
;


var Badge = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Badge2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .mq)("Badge", props);
  const { className, ...rest } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.span */ .m.span,
    {
      ref,
      className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-badge", props.className),
      ...rest,
      __css: {
        display: "inline-block",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        ...styles
      }
    }
  );
});
Badge.displayName = "Badge";


//# sourceMappingURL=chunk-Z6RXEUPO.mjs.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9048,296,6189,78,1879,9150,5625,3849,2677,2297,9774,2888,179], function() { return __webpack_exec__(84206); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);